import fs from "node:fs";
import os from "node:os";
import path from "node:path";

export interface ConfigTemplateType {
  name: string;
  regex: string;
  pattern: string;

  pre_type?: string;
  post_type?: string;
  pre_scope?: string;
  post_scope?: string;
  pre_description?: string;
  post_description?: string;
  pre_body?: string;
  post_body?: string;

  pre_issue?: string;
  post_issue?: string;
  pre_issue2?: string;
  post_issue2?: string;
  pre_issue3?: string;
  post_issue3?: string;
}

export interface ConfigType {
  $schema: "https://www.4s1.de/conventional-commit-creator/schema.json";
  version: number;
  templates: ConfigTemplateType[];
}

export function loadConfig(): ConfigType {
  const configFile = `${os.homedir()}/.config/conventional-commit-creator/config.json`;

  if (fs.existsSync(configFile)) {
    const config = fs.readFileSync(configFile, { encoding: "utf-8" });
    return JSON.parse(config);
  } else {
    const config: ConfigType = {
      $schema: "https://www.4s1.de/conventional-commit-creator/schema.json",
      version: 1,
      templates: [
        {
          name: "Default",
          regex: ".*",
          pattern: "{type}{scope}: {description}{issue}{body}",

          pre_type: "",
          post_type: "",
          pre_scope: "(",
          post_scope: ")",
          pre_description: "",
          post_description: "",
          pre_body: "\n\n",
          post_body: "",

          pre_issue: " (#",
          post_issue: ")",
          pre_issue2: "",
          post_issue2: "",
          pre_issue3: "",
          post_issue3: "",
        },
      ],
    };
    fs.mkdirSync(path.dirname(configFile), { recursive: true });
    fs.writeFileSync(configFile, JSON.stringify(config, null, 2), { encoding: "utf-8" });
    return config;
  }
}
